import { render, staticRenderFns } from "./AutoAppliedCoupon.vue?vue&type=template&id=36a89ecc"
import script from "./AutoAppliedCoupon.vue?vue&type=script&lang=js"
export * from "./AutoAppliedCoupon.vue?vue&type=script&lang=js"
import style0 from "./AutoAppliedCoupon.vue?vue&type=style&index=0&id=36a89ecc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports